import tippy from 'tippy.js';
// import 'tippy.js/dist/tippy.css';

export default () => ({

    init () {
        const tooltip = this.$refs.tooltip

        tippy(tooltip, {
            content: "Призначено",
        })
    }
})